/**
 * @generated SignedSource<<07524952c4e2c2a4c7f544be9e8d7758>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedDescription_buyPage$data = {
  readonly description: string | null;
  readonly " $fragmentType": "BuySharedDescription_buyPage";
};
export type BuySharedDescription_buyPage$key = {
  readonly " $data"?: BuySharedDescription_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedDescription_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedDescription_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "116f3079323f4cfbbb322b1d436e66a6";

export default node;
